export default "<p>\n  name-editor works!\n</p>\n";